module.exports = __webpack_public_path__ + "outline-icons.ad97afd3337e8cda302d.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/outline-icons.ttf
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/outline-icons.ttf
// module chunks = styles